import StitchFeaturePage from "../../components/sections/StitchFeaturePage";

const features = [
  { title: "Store Architecture", desc: "Catalog, collections, and conversion pathways designed for high-volume commerce." },
  { title: "Theme Engineering", desc: "Fast, premium Shopify experiences with custom sections and robust maintainability." },
  { title: "Checkout Optimization", desc: "Payment, shipping, and trust signals tuned to reduce cart abandonment." },
  { title: "App Ecosystem", desc: "Integrations with subscriptions, loyalty, reviews, fulfillment, and CRM workflows." },
  { title: "Lifecycle Automation", desc: "Email, SMS, and remarketing sequences that increase repeat purchase rates." },
  { title: "Scale Readiness", desc: "Infrastructure and operating setup prepared for traffic spikes and seasonal demand." },
];

const Shopify = () => (
  <StitchFeaturePage
    label="WEB & DIGITAL"
    title="Shopify stores that"
    titleAccent="sell at scale."
    subtitle="From launch to growth-stage optimization, we build Shopify ecosystems that compound revenue."
    features={features}
    ctaLabel="BUILD MY STORE"
  />
);

export default Shopify;